/**
 * Helper to build Cloudflare on-the-fly resized image URLs from Auxo asset CDN
 * e.g. https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/...
 */
export function getOptimizedImageUrl(url, options = {}) {
  if (!url || typeof url !== 'string') return ''
  if (!url.startsWith('https://assets.auxodev.dk/')) return url
  if (url.includes('/cdn-cgi/image/')) return url

  const { width = 800, height, quality = 85, fit = 'cover' } = options
  const parts = ['format=auto', `quality=${quality}`]

  if (width) parts.push(`width=${width}`)
  if (height) parts.push(`height=${height}`, `fit=${fit}`)

  const params = parts.join(',')
  return url.replace('https://assets.auxodev.dk/', `https://assets.auxodev.dk/cdn-cgi/image/${params}/`)
}

export function getImageSrcSet(url, widths = [400, 800, 1200, 1600]) {
  if (!url || typeof url !== 'string' || !url.startsWith('https://assets.auxodev.dk/')) return undefined
  if (url.includes('/cdn-cgi/image/')) return undefined

  return widths
    .map(w => `${getOptimizedImageUrl(url, { width: w })} ${w}w`)
    .join(', ')
}
